import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import TileContent from "ds/components/Tile/Content";
import TileTitle from "ds/components/Tile/Title";
import TileWrapper from "ds/components/Tile/Wrapper";
import { AnalyticsPageBilling } from "hooks/useAnalytics/pages/billing";
import useTypedContext from "hooks/useTypedContext";

import BillingFeatureItem from "../components/FeatureItem";
import BillingUpgradeAvailableBox from "../components/UpgradeAvailableBox";
import { BillingContext } from "../Context";
import { PLAN_FEATURES_BY_TIER, PLAN_UPGRADE_BOX_BY_TIER } from "./constants";

const BillingPlanDetailsTile = () => {
  const { tier } = useTypedContext(BillingContext);

  const features = PLAN_FEATURES_BY_TIER[tier];
  const upgradeBox = PLAN_UPGRADE_BOX_BY_TIER[tier];

  if (!features) {
    return null;
  }

  return (
    <TileWrapper>
      <TileContent gap="x-large">
        <Box justify="between" align="center" gap="medium">
          <TileTitle variant="p-t6">Included in your plan</TileTitle>
          <LinkButton
            href="https://spacelift.io/pricing"
            target="_blank"
            variant="secondary"
            size="small"
            analyticsPage={AnalyticsPageBilling.BillingDashboard}
            analyticsTitle="Plan Details Button Clicked"
          >
            Plan details
          </LinkButton>
        </Box>
        <Box grid gridTemplate="1fr 1fr" gap="medium">
          {features.map(({ text, negative, infoTooltip }, index) => (
            <BillingFeatureItem
              key={index}
              text={text}
              negative={negative}
              infoTooltip={infoTooltip}
            />
          ))}
        </Box>
        {upgradeBox && (
          <BillingUpgradeAvailableBox title={upgradeBox.title} items={upgradeBox.items} />
        )}
      </TileContent>
    </TileWrapper>
  );
};

export default BillingPlanDetailsTile;
